import { Alert, Autocomplete, Box, Button, Card, CardActions, CardContent, CardHeader, Chip, Divider, IconButton, Stack, TextField, Typography } from "@mui/material";
import { calcMargem, formatData, formatMoney, getNewId, isEmpty } from "../../../services/utils";
import ViewCad from "../../../view";
import { mapDispatchToMovProps, mapStateToMovProps, movController, MovViewProps } from "../mov.controll";
import { intialValueMovimentacao, Movimentacao } from "../mov.model";
import { ContentForm, FormCad } from "../../../components/viewCadastro/formCad";
import ClienteSelect, { ViewSelecionarCliente } from "../../cliente/view/cliente.select";
import { Endereco, initialValueEndereco, Item, ItemMov, MeioPagMov, Pessoa, TipoMovDesc } from "../../../data.types";
import { Add, Cancel, Check, ContentCopy, DeliveryDining, Discount, FilePresent, Handshake, LocationOn, Mp, Newspaper, Payments, Search, Task } from "@mui/icons-material";
import EditDocumentIcon from "@mui/icons-material/EditDocument"
import ItemSelect from "../../item/view/item.select";
import { memo, useCallback, useEffect, useState } from "react";
import Modal from "../../../components/modal";
import { ItemMovList } from "./itemMov.list";
import MeiopgSelect from "../../meioPag/view/meiopg.select";
import { format } from "path";
import { MeioPagActions } from "../../meioPag/meiopg.model";
import { FuncionarioActions } from "../../funcionario/funcionario.model";
import { PedidoTemplate } from "./components/temp.pedido";
import { TemplateCompra } from "./components/temp.compra";
import { TemplateVenda } from "./components/temp.venda";
import { configController } from "../../config/config.controll";
import { TemplateAvaria } from "./components/temp.avaria";
import { navigationToTipoMovView } from "../../tipoMov/tipomov.router"
import { connect } from "react-redux";
import { propsStateInitializer } from "@mui/x-data-grid/internals";
import { contasController } from "../../contas/contas.controll";
import { Cliente } from "../../cliente/cliente.model";

interface MovCadastroProps extends MovViewProps {
  handleCloseView?: () => any
  meioPagActions: MeioPagActions
}

export function MovCadastro(props: MovCadastroProps) {
  const { movActions, movState, handleCloseView, tipoMovState, meioPagActions, clienteActions, funcionarioActions, fornecedorActions, itemActions } = props
  const { error, loading, msg, row, showAlert, showDialogExluir, status, showCadModal } = movState
  const { createMovimentacao, read, update, deleteMov, set, get, setShowAlert, setShowDialogExluir, setClearValue, setShowCadModal, setRowsMovGroup, setShowMsg } = movActions


  const handleNovo = () => {
    console.log("handleNovo configControler", configController.state.row)
    let newMov: Movimentacao = {
      ...structuredClone(intialValueMovimentacao),
      tipo_mov: tipoMovState.row,
      created_at: new Date().toISOString(),
      local: "loja",
    };
    switch (tipoMovState.row.descricao) {
      case TipoMovDesc.COMPRA:
        set(newMov)
        fornecedorActions.setShowSelectModal(true);
        break;
      case TipoMovDesc.PEDIDO:
        set(newMov)
        clienteActions.setShowSelectModal(true);
        break;
      case TipoMovDesc.AVARIA:
        set(newMov)
        funcionarioActions.setShowSelectModal(true);
        break;
      default:
        //venda processo é diferente por causa do canal de distribuicao relacionado
        props.movActions.newMovVenda()
        break;
    }
  }

  const handleExcluir = (row: Movimentacao) => {
    deleteMov(row);
    setShowDialogExluir(false);
    handleCloseViewLocal();
  }

  const handleCloseViewLocal = () => {
    setShowCadModal(false);
    setRowsMovGroup({ situacao: "", rows: [] })
    //setClearValue();
  }

  const formValidate = (movs: Movimentacao) => {
    const errors: any = {}
    if (!movs.pessoa.nome)
      errors.pessoa = "Informe a pessoa"
    if (movs.itens.length === 0) {
      errors.itens = "Adicione pelo menos um item."
    }
    if (movs.tipo_mov.descricao === TipoMovDesc.COMPRA) {
      if (movs.codigo === "")
        errors.codigo = "Informe o numero da nota"
    }
    return errors
  }

  const handleUpdate = (mov: Movimentacao) => {
    console.log("chamou salvar", mov)
    if (!mov._rev) {
      createMovimentacao(mov);
    } else {
      update(mov);
    }
  }

  const handleMutator = ([value, field]: any, state: any, { changeValue }: any) => {
    try {
      console.log("handleMutator", [field, value, state])

      const verificarMeioPagPadrao = () => {
        /**Verificar se o cliente tem uma forma de pagamento ja definida como padrao
         * se tive, ja adiciona esse meio de pagamento quando o item for adicionado, seguindo os passos:
         * pega o total de calcTotal
         * monta a estrutado do meio de pagamento para a mov
         * busca os meios da mov, buscar o meio padrao, se encontrar atualizar o valor, se nao adicionar um novo registro
         */
        let total = calcTotal();
        let pessoa = state.formState.values.pessoa as Cliente;
        if (pessoa.meio_pag_default?._id) {
          let meioPag: MeioPagMov = {
            ...pessoa.meio_pag_default,
            valor: total,
            sit_pag: "aberto"
          }
          let meiosPag: MeioPagMov[] = [...state.formState.values.fechamento.pagamentos];
          let findIdx = meiosPag.findIndex(row => row._id === meioPag._id)
          if (findIdx !== -1) {
            //encontrou, atualiza o valor
            meiosPag[findIdx].valor = total;
          } else {
            meiosPag.push(meioPag)
          }
          changeValue(state, "fechamento.pagamentos", () => meiosPag)
        }
      }

      const calcTotal = () => {
        let itensMov: ItemMov[] = state.formState.values.itens;
        let subTotal = itensMov.map(item => item.total).reduce((a, b) => a + b, 0)
        let total = subTotal;
        if (subTotal === 0) {
          changeValue(state, "fechamento.descontos", () => 0);
        } else {
          total = subTotal - state.formState.values.fechamento.descontos;
        }

        changeValue(state, "fechamento.subtotal", () => subTotal)
        changeValue(state, "fechamento.total", () => total)
        return subTotal;
      }

      switch (field) {
        case "itemMovAdd": {
          let itensMov: ItemMov[] = state.formState.values.itens;
          let findIdx = itensMov.findIndex(row => row.item._id === value.item._id)
          if (findIdx !== -1) {
            let qt = itensMov[findIdx].qt + value.qt;
            let total = qt * Number(value.valor.toFixed(2));
            itensMov[findIdx].qt = qt;
            itensMov[findIdx].total = total;
          } else {
            itensMov.push(value);
          }
          changeValue(state, "itens", () => itensMov)
          verificarMeioPagPadrao();
          break;
        }

        case "itemMovUpd": {
          let itensMov: ItemMov[] = state.formState.values.itens;
          let findIdx = itensMov.findIndex(row => row._id === value._id)
          if (findIdx !== -1) {
            itensMov[findIdx].qt = value.qt
            itensMov[findIdx].valor = value.valor
            itensMov[findIdx].total = value.total
            itensMov[findIdx].ano_validade = value.ano_validade
          }
          changeValue(state, "itens", () => itensMov)
          verificarMeioPagPadrao();
          break;
        }

        case "itemMovRem": {
          let itensMov: ItemMov[] = state.formState.values.itens;
          let findIdx = itensMov.findIndex(row => row.item._id === value.item._id)
          itensMov.splice(findIdx, 1)
          changeValue(state, "itens", () => itensMov)
          verificarMeioPagPadrao();
          break;
        }
        case "meioPagAdd": {
          let meiosPag: MeioPagMov[] = [...state.formState.values.fechamento.pagamentos];
          let findIdx = meiosPag.findIndex(row => row._id === value._id)
          if (findIdx !== -1) {
            //encontrou, soma o valor
            meiosPag[findIdx].valor = meiosPag[findIdx].valor + value.valor
          } else {
            meiosPag.push(value)
          }
          changeValue(state, "fechamento.pagamentos", () => meiosPag)
          break;
        }
        case "meioPagRem": {
          let meiosPag: MeioPagMov[] = [...state.formState.values.fechamento.pagamentos];
          let findIdx = meiosPag.findIndex(row => row._id === value._id)
          meiosPag.splice(findIdx, 1)
          changeValue(state, "fechamento.pagamentos", () => meiosPag)
          break;
        }
        case "meioPagUp": {
          let meiosPag: MeioPagMov[] = [...state.formState.values.fechamento.pagamentos];
          let findIdx = meiosPag.findIndex(row => row._id === value._id)
          if (findIdx !== -1) {          
            meiosPag[findIdx] = value
          }
          changeValue(state, "fechamento.pagamentos", () => meiosPag)
          break;
        }
        case "canal_dist": {
          changeValue(state, "canal_dist", () => value)
          changeValue(state, "situacao", () => "ENTREGA")
          changeValue(state, "data_situacao", () => new Date().toISOString())
          break;
        }
        case "situacao": {
          changeValue(state, "situacao", () => value)
          changeValue(state, "data_situacao", () => new Date().toISOString())
          break;
        }
        case "desconto": {
          changeValue(state, "fechamento.descontos", () => value)
          changeValue(state, "fechamento.total", () => state.formState.values.fechamento.subtotal - value)
          break;
        }
        case "pessoa": {
          let pessoa = {
            _id: value._id,
            nome: value.nome,
            whatsapp: value.whatsapp,
            enderecos: value.enderecos,
            revenda: value.revenda ? value.revenda : false,
            meio_pag_default:value.meio_pag_default,
            tabela_preco_padrao:value.tabela_preco_padrao,
          }
          changeValue(state, field, () => pessoa)
          if (value.enderecos.length > 0) {
            changeValue(state, "entrega", () => value.enderecos[0])
          } else {
            changeValue(state, "entrega", () => undefined)
          }
          let itensMov: ItemMov[] = state.formState.values.itens;
          if(itensMov.length > 0){
            verificarMeioPagPadrao();
          }

          break;
        }
        case "entrega": {
          let end: Endereco = value;
          let entrega = {
            ...structuredClone(initialValueEndereco),
            ...end
          }

          changeValue(state, "entrega", () => entrega)
          break;
        }
        default:
          var teste = changeValue(state, field, () => value)
          if(field === "situacao" && value === "FINALIZADO"){
            console.log("resultado finalizacao",teste,state)
          }
          break;
      }

    } catch (error) {
      console.log("Error handleMutator", error);
    }
  }

  const Content = useCallback((props: any) => {
    const [showObsModal, setShowObsModal] = useState(false)
    const [showDescontoModal, setShowDescontoModal] = useState(false)
    const mutatorLocal: (v: any, f: any) => any = props.form.mutators.handleMutator
    const stateForm = props.form.getState();
    const mov: Movimentacao = props.values

    var msgError = ""
    if (stateForm.invalid) {
      for (const key in stateForm.errors) {
        if (Object.prototype.hasOwnProperty.call(stateForm.errors, key)) {
          const msg = stateForm.errors[key];
          msgError = msgError + msg + '\n'
        }
      }
    }


    function getTextMovToShared() {
      const descTabelaPreco = (row: ItemMov) => isEmpty(row.item.tabela_preco) ? " " : ` (${row.item.tabela_preco.descricao}) `;
      var text = "";
      text = mov.tipo_mov.descricao + " : " + mov.codigo + "\n";
      text = text + "Rua: " + mov.entrega?.rua + " N°" + mov.entrega?.numero + " - Bairro: " + mov.entrega?.bairro + "\n";
      if (mov.entrega?.complemento)
        text = text + mov.entrega?.complemento + "\n";
      for (let i = 0; i < mov.itens.length; i++) {
        const item = mov.itens[i];
        text = `${text + item.qt} - ${item.item.descricao} ${descTabelaPreco(item)} ${formatMoney(item.total)}`
        if (item.ano_validade) {
          text = text + " Ano: " + item.ano_validade;
        }
        text = text + "\n"
      }
      if (mov.fechamento.descontos > 0) {
        text = text + "Desconto: " + formatMoney(mov.fechamento.descontos) + "\n";
        text = text + "Total com desconto: " + formatMoney(mov.fechamento.total) + "\n";
      } else {
        if (mov.itens.length > 0) {
          text = text + "Total: " + formatMoney(mov.fechamento.total) + "\n";
        }
      }

      text = text + "Cliente: " + mov.pessoa.nome + " - " + mov.pessoa.whatsapp + "\n"
      if (mov.obs)
        text = text + "Obs: " + mov.obs + "\n"
      if (mov.entrega?.contato && !isEmpty(mov.entrega.contato.nome)) {
        text = text + "Recebedor: " + mov.entrega.contato.nome + " - " + mov.entrega.contato.whatsapp + "\n";
      }
      return text
    }


    switch (tipoMovState.row.descricao) {
      case TipoMovDesc.PEDIDO:
        return (
          <PedidoTemplate
            clienteActions={clienteActions}
            fornecedorActions={fornecedorActions}
            funcionarioActions={funcionarioActions}
            meioPagActions={meioPagActions}
            mutatorLocal={mutatorLocal}
            mov={mov}
            tipoMovState={tipoMovState}
            setShowObsModal={setShowObsModal}
            showObsModal={showObsModal}
            setShowDescontoModal={setShowDescontoModal}
            showDescontoModal={showDescontoModal}
            getTextMovToShared={getTextMovToShared}
            msgError={msgError}
            stateForm={stateForm}
          />
        )
      case TipoMovDesc.VENDA:
        return (
          <TemplateVenda
            clienteActions={clienteActions}
            fornecedorActions={fornecedorActions}
            funcionarioActions={funcionarioActions}
            meioPagActions={meioPagActions}
            itemActions={itemActions}
            mutatorLocal={mutatorLocal}
            mov={mov}
            setShowDescontoModal={setShowDescontoModal}
            showDescontoModal={showDescontoModal}
          />
        )
      case TipoMovDesc.COMPRA:
        return (
          <TemplateCompra
            clienteActions={clienteActions}
            fornecedorActions={fornecedorActions}
            funcionarioActions={funcionarioActions}
            itemActions={itemActions}
            mutatorLocal={mutatorLocal}
            mov={mov}
            setShowDescontoModal={setShowDescontoModal}
            showDescontoModal={showDescontoModal}
          />
        )
      case TipoMovDesc.AVARIA:
        return (
          <TemplateAvaria
            clienteActions={clienteActions}
            fornecedorActions={fornecedorActions}
            funcionarioActions={funcionarioActions}
            itemActions={itemActions}
            mutatorLocal={mutatorLocal}
            mov={mov}
            setShowDescontoModal={setShowDescontoModal}
            showDescontoModal={showDescontoModal}
          />
        )
      default:
        return (
          <Stack >
            <Typography variant="h5" color="primary" sx={{ marginBottom: 1 }}>Outros</Typography>
          </Stack>
        )
    }
  }, [row._rev, loading, showDialogExluir])

  const getOrigem = () => {
    switch (row.local) {
      case "app": return "Aplicativo";
      case "loja": return "Loja";
      case "bot": return "IA Agente";
      default: return "Não Definido";
    }
  }

  const getSubtitle = () => {
    if (row.tipo_mov) {
      switch (row.tipo_mov.descricao) {
        case TipoMovDesc.PEDIDO:
          return `${row.codigo} - Origem ( ${getOrigem()} )`;
        case TipoMovDesc.VENDA:
          return `${row.codigo} - Origem ( ${getOrigem()} )`;
        default: return row.codigo
      }
    }
  }

  var viewCad = new ViewCad({
    formTitle: tipoMovState.row.descricao + " - " + row.situacao,
    formSubtitle: getSubtitle(),
    formFieldDescription: "codigo",
    loading: loading,
    msg: msg,
    row: row,
    status: status,
    showAlert: showAlert,
    showDialogExluir: showDialogExluir,
    buttonNovo: {
      show: true,
      title: "Adicionar novo " + tipoMovState.row.descricao,
      onClick: () => handleNovo(),
    },
    handleExcluir: handleExcluir,
    formValidate: formValidate,
    handleUpdate: handleUpdate,
    handleCloseAlert: () => setShowAlert(false),
    setShowDialogExluir: setShowDialogExluir,
    handleCloseView: () => handleCloseViewLocal(),
    handleMutator: handleMutator,
    contentForm: [
    ],
    ContentBox: Content
  })


  return viewCad
}

const MovCadastroViewModal = (props: MovCadastroProps) => {
  const { setRowsMovGroup, setShowCadModal } = props.movActions
  const { showCadModal } = props.movState
  //const [showCadModal, setShowCadModal] = useState(true)
  const handleCloseCadastro = () => {
    props.handleCloseView ? props.handleCloseView() : null
    setShowCadModal(false)
    //setRowsMovGroup({ situacao: "", rows: [] })
  }
  return MovCadastro({ ...props }).renderModal({
    handleClose: handleCloseCadastro,
    show: showCadModal,
    width: "xl",
    heigth: "100%",
  });
}
const MovCadastroViewEl = memo((props: MovCadastroProps) => {

  return (
    <Box>
      <MovCadastroViewModal {...props} />
    </Box>
  )
}, (prevProps, nextProps) => {
  console.log("MovCadastroViewEl props comparation", {
    prevId: prevProps.movState.row._id,
    nextId: nextProps.movState.row._id,
    prevLoading: prevProps.movState.loading,
    nextLoading: nextProps.movState.loading,
    prevShowCadModal: prevProps.movState.showCadModal,
    nextShowCadModal: nextProps.movState.showCadModal,
  });
  return prevProps.movState.row._id === nextProps.movState.row._id &&
    prevProps.movState.row._rev === nextProps.movState.row._rev &&
    prevProps.movState.loading === nextProps.movState.loading &&
    prevProps.movState.showCadModal === nextProps.movState.showCadModal &&
    prevProps.movState.showDialogExluir === nextProps.movState.showDialogExluir;
});

export const MovCadastroView = connect(mapStateToMovProps, mapDispatchToMovProps)(MovCadastroViewEl);
export default connect(mapStateToMovProps, mapDispatchToMovProps)(MovCadastroViewModal);
